"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const deserializeUserWithStatistics = ({ lastSeenAt, ...rest }) => ({
    ...rest,
    lastSeenAt: lastSeenAt
        ? new Date(lastSeenAt)
        : undefined
});
exports.default = deserializeUserWithStatistics;
